import { useState } from "react";
import Button from "src/components/Button";
import FormGroup from "src/components/form/FormGroup";
import FileUpload from "src/components/form/file-upload/FileUpload";
import withTranslation, {
	Translation,
} from "src/components/hoc/withTranslation";
import useAuth from "src/hooks/selectors/useAuth";

const ResumeAvatar = ({ t }: Translation) => {
	const auth = useAuth();
	const [media, setMedia] = useState(auth.media);
	const savedMedia = auth.media;

	const handleSave = () => {
		if (!media) {
			return;
		}
		setMedia({});
	};

	return (
		<FormGroup noMarginBottom label={t("title")}>
			<div className="flex flex-1 flex-row gap-4 items-center">
				<FileUpload type="avatar" onChange={setMedia} value={media} />
				<div className="flex flex-col gap-1">
					{media?.id && savedMedia?.id !== media?.id && (
						<Button xsmall type="ghost" onClick={handleSave}>
							{t("save")}
						</Button>
					)}
					{savedMedia?.id && savedMedia.id === media?.id && (
						<Button
							xsmall
							type="ghost"
							onClick={() => setMedia({})}
						>
							{t("edit")}
						</Button>
					)}
				</div>
			</div>
		</FormGroup>
	);
};

ResumeAvatar.locale = {
	nl: {
		title: "Profielfoto",
		save: "Upload foto",
		edit: "Aanpassen",
	},
	en: {
		title: "Profile picture",
		save: "Upload photo",
		edit: "Edit",
	},
};

export default withTranslation(ResumeAvatar);
